import { request } from "../../utils/request";

/** TTS 模型枚举（与后端 doc/接口文档 一致） */
export type TtsModel = "Lychee Voice_TTS_PRO" | "MIMO_TTS";

/** 文本转语音 - 生成请求参数 */
export interface TtsGenerateReq {
  /** 音色 ID */
  voiceId: number;
  /** voiceId 来源类型 */
  voiceSourceType: "PUBLIC_VOICE_TONE" | "USER_VOICE_TONE";
  /** 输入文本，最多 3000 字符 */
  text: string;
  /**
   * TTS 模型
   * 必需，可选值：`Lychee Voice_TTS_PRO`、`MIMO_TTS`
   * 示例：`Lychee Voice_TTS_PRO`
   */
  model: TtsModel;
}

/** 文本转语音 - 生成响应 */
export interface TtsGenerateResp {
  /** 历史记录 ID */
  recordId: number;
  /** 生成音频 URL */
  audioUrl: string;
}

/**
 * 文本转语音 - 生成
 * 接口：POST /video/tts/generate
 */
export const ttsGenerateApi = (body: TtsGenerateReq) =>
  request<{ code: number; data: TtsGenerateResp; msg: string }>("/video/tts/generate", {
    method: "POST",
    body,
  });

/** 文本转语音 - 历史记录项 */
export interface TtsHistoryItem {
  id: number;
  voiceId: number;
  voiceName: string;
  model: string;
  text: string;
  textLength: number;
  audioUrl: string;
  audioSize: number;
  durationMs: number;
  status: number;
  errorMsg: string;
  createTime: string;
}

/** 文本转语音 - 历史记录分页响应 */
export interface TtsHistoryPageResp {
  list: TtsHistoryItem[];
  total: number;
}

/** 文本转语音 - 历史记录查询参数 */
export interface TtsHistoryPageParams {
  pageNo: number;
  pageSize: number;
  voiceId?: number;
  model?: string;
}

/**
 * 分页查询文本转语音历史
 * 接口：GET /video/tts/history/page
 */
export const ttsHistoryPageApi = (params: TtsHistoryPageParams) =>
  request<{ code: number; data: TtsHistoryPageResp; msg: string }>("/video/tts/history/page", {
    method: "GET",
    params,
  });

/**
 * 删除文本转语音历史
 * 接口：DELETE /video/tts/history/{id}
 * 响应：{ code: number; data: boolean; msg: string }
 */
export const ttsHistoryDeleteApi = (id: number) =>
  request<{ code: number; data: boolean; msg: string }>(`/video/tts/history/${id}`, {
    method: "DELETE",
  });

/** 文本转语音 - 模板项 */
export interface TtsTemplateItem {
  id: number;
  title: string;
  description: string | null;
  script: string;
  coverImageUrl: string | null;
  sampleAudioUrl: string | null;
  /** 模板参考音色 id（字符串格式） */
  voiceId?: string | null;
}

/**
 * 文本转语音 - 模板列表
 * 接口：GET /video/tts/template
 */
export const ttsTemplateApi = () =>
  request<{ code: number; data: TtsTemplateItem[]; msg: string }>("/video/tts/template", {
    method: "GET",
  });